import styled from 'styled-components'

export const QuestionListItemNumberUi = styled.div`
  font-size: 20px;
  padding-right: 5px;
`
